const AboutPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">About Medical Code Finder</h1>

        <div className="space-y-8">
          <section className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
            <p className="text-gray-700 leading-relaxed">
              Medical Code Finder is a free, AI-powered tool designed to help healthcare
              professionals quickly find and understand medical codes. We believe that
              access to accurate medical coding information should be free and easy for everyone.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-bold mb-4">What We Cover</h2>
            <ul className="space-y-2 text-gray-700">
              <li>• <strong>ICD-10-CM:</strong> 72,000+ diagnosis codes</li>
              <li>• <strong>ICD-10-PCS:</strong> 87,000+ procedure codes</li>
              <li>• <strong>HCPCS:</strong> 6,000+ supply and service codes</li>
              <li>• <strong>NDC:</strong> 100,000+ drug codes</li>
              <li>• <strong>LOINC:</strong> 95,000+ lab test codes</li>
              <li>• <strong>SNOMED CT:</strong> 350,000+ clinical terms</li>
              <li>• <strong>RxNorm:</strong> Medication names and relationships</li>
            </ul>
          </section>

          <section className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-bold mb-4">Data Sources</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              All our data comes from official government and non-profit sources:
            </p>
            <ul className="space-y-2 text-gray-700">
              <li>• Centers for Medicare & Medicaid Services (CMS)</li>
              <li>• Food and Drug Administration (FDA)</li>
              <li>• National Library of Medicine (NLM)</li>
              <li>• Regenstrief Institute (LOINC)</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Our database is automatically updated daily to ensure you always have
              access to the latest codes.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-bold mb-4">Disclaimer</h2>
            <p className="text-gray-700 leading-relaxed">
              Medical Code Finder is a reference tool only. While we strive for accuracy,
              this tool should not replace professional medical coding expertise. Always
              verify codes at official sources before billing. We are not responsible for
              any coding errors or claim denials.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-bold mb-4">Contact</h2>
            <p className="text-gray-700 leading-relaxed">
              Have questions or feedback? We'd love to hear from you!
            </p>
            <p className="text-gray-700 mt-4">
              Email: <a href="mailto:support@medicalcodefinder.com" className="text-primary-600 hover:underline">
                support@medicalcodefinder.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;